module.exports = __webpack_public_path__ + "static/img/home_order.65d24cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/image/home_order.png
// module id = 1SyJ
// module chunks = 1